<template>
	<v-container fluid class="pa-0 ma-0">
		<div v-if="!loading">
			
			<!--for lg desctop and middle-->
			<div class="hidden-sm-and-down">
				<!-- <video playsinline autoplay muted loop poster="@/assets/poster.png" id="bgvideo" 
					width="100%" height="65%">
					<source :src="require('@/assets/video_bg.mp4')" type="video/mp4">
				</video> -->
				<video-background 
					src="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/video_bg.mp4?alt=media&token=00cd04a6-c73c-47b2-ba25-4c4d8a9bfa52"
					poster="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/poster.png?alt=media&token=dcfd7b94-7af0-44f1-bf32-8e6cc27ee245"
					style="max-height: 75.5vh; height: 75.5vh;">
				</video-background>
				
				<v-card class="left">
					<v-row justify="start">
						<v-overlay 
							:absolute="overlay" opacity=".6"
							:z-index="0"
							>
							<h3>{{ 'Business strategy game'| localize }}</h3>
							<!--button sign In -->
							<v-btn color="accent" 
								class="text-lowercase my-4 text--primary"
								dark to="/login">
								{{ 'get started' | localize }}
							</v-btn>
							<h3>{{ 'Business strategy tutorials'| localize }}</h3>
							<v-btn
								color="accent"
								class="text-lowercase mt-4 text--primary"
								target="_blank"
								href="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/Dolfy_Practical_Marketing_User_Guide_full.pdf?alt=media&token=7b3a52e7-69d5-416e-bb94-83cb8a7a2190"
								>{{ 'get started' | localize }}
							</v-btn>
						</v-overlay>
					</v-row>
				</v-card>
			</div>
			
			<!--for mobile -->
			<div class="hidden-md-and-up">
				
					<video-background 
						src="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/video_bg.mp4?alt=media&token=00cd04a6-c73c-47b2-ba25-4c4d8a9bfa52"
						poster="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/poster.png?alt=media&token=dcfd7b94-7af0-44f1-bf32-8e6cc27ee245"
						style="max-height: 100hv; height: 100vh;">
					</video-background>
				
					<v-card class="all">
						<v-row justify="start">
							<v-overlay 
								:absolute="overlay" opacity=".6"
								:z-index="0"
								>
								<h4>{{ 'Business strategy game' | localize }}</h4>
								<!--button sign In -->
								<v-btn color="accent" 
									class="text-lowercase my-4 text--primary"
									dark to="/login">
									{{ 'get started' | localize }}
								</v-btn>
								<h4>{{ 'Business strategy tutorials' | localize }}</h4>
								<v-btn
									color="accent"
									class="text-lowercase mt-4 text--primary"
									target="_blank"
									href="https://firebasestorage.googleapis.com/v0/b/stras-45a96.appspot.com/o/Dolfy_Practical_Marketing_User_Guide_full.pdf?alt=media&token=7b3a52e7-69d5-416e-bb94-83cb8a7a2190"
									>{{ 'get started' | localize }}
								</v-btn>
							</v-overlay>
						</v-row>
					</v-card>
			</div>
			
			<!--footer-->
			<v-row class="over hidden-sm-and-down">
				<app-footer></app-footer>
			</v-row>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-container>
</template>
<script>
import AppFooter from '@/layouts/AppFooter.vue'
import Loader from '../layouts/Loader.vue'
import VideoBackground from 'vue-responsive-video-background-player';

	export default {

		data () {
			return {
				overlay: true,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			loggedIn () {
				return this.$store.getters.loggedIn
			},
			locale() {
				return this.$store.getters.locale;
			}
		},
		methods: {
		},
		components: {
			AppFooter,
			Loader,
			VideoBackground,
		}
	}
</script>
<style>
	.left { 
		margin-top: -76vh;
		height: 76vh;
		width: 30%;
		text-align: right;
		background-color: transparent !important;
	}
	.all {
		margin-top: -100vh;
		height: 100vh;
		width: 100%;
		text-align: center;
		background-color: transparent !important;
	}
	.over{
		position:relative;
	}
	
</style>